import React from "react";
import Toolbar from "@mui/material/Toolbar";
import {
  AppBar,
  styled,
  Container,
  Grid,
  Typography,
  Stack,
} from "@mui/material";

import "./textStyle.css";

import Circle from "../Circle/Circle";
import bg_final from "../../images/bg_homepage.png";

import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TelegramIcon from "@mui/icons-material/Telegram";

const StackStyle = {
  color: "white",
  position: "absolute",
  top: "40vh",
  right: "3vw",
  lineHeight: "2px",
  fontSize: "2px",
};

const iconStyle = {
  color: "white",
};

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
  backgroundColor: "transparent",
  fontFamily: "sans-serif",
});

const Home = () => {
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          backgroundImage: "url(" + bg_final + ")",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        }}
      >
        <AppBar
          position="static"
          elevation={0}
          style={{ backgroundColor: "transparent" }}
        >
          <StyledToolbar flex={1}></StyledToolbar>
        </AppBar>

        <Container
          maxWidth={"lg"}
          className="content"
          style={{ marginTop: "2%", marginBottom: "10%" }}
        >
          <Grid
            container
            alignItems={"center"}
            justifyContent={"center"}
            wrap={"wrap-reverse"}
          >
            <Grid item md={8} sm={7} xs={12} style={{ zIndex: "1" }}>
              <div className="head">
                <h6 className="sidehead">An O(1) Product</h6>
                <p className="heroName">
                  <span className="firsthead">SmartLearn</span>
                </p>
              </div>

              <Typography className="para">
                <Typography fontSize={"x-large"} fontWeight={"bold"}>
                  Unlock the Power of Hybrid Learning
                </Typography>
                SmartLearn combines the best of both worlds: traditional
                classroom learning and cutting-edge digital resources. With our
                platform, you can access a treasure trove of educational
                materials that will enhance your learning experience and take
                your understanding to new heights.
              </Typography>

              <div className="btn-container">
                <button
                  className="btn-giveTest"
                  onClick={() => (window.location.href = "/login")}
                >
                  Login
                </button>
                <button
                  className="btn-giveTest"
                  onClick={() => (window.location.href = "/reset-password")}
                  style={{
                    width: "13rem",
                  }}
                >
                  Reset Password
                </button>
              </div>
            </Grid>
            <Grid item md={4} sm={5} xs={8}>
              <Circle />
            </Grid>
          </Grid>
        </Container>

        <Stack style={StackStyle}>
          <a
            href="https://www.linkedin.com/in/o-1-coding-club/?originalSubdomain=in"
            target="_blank"
          >
            <LinkedInIcon sx={iconStyle} />
          </a>
          <a href="https://t.me/+diEKUu4Y-oY3NDFl" target="_blank">
            <TelegramIcon sx={iconStyle} />
          </a>
          <a
            href="https://www.instagram.com/o1codingclub/?hl=en"
            target="_blank"
          >
            <InstagramIcon sx={iconStyle} />
          </a>
          <a
            href="https://www.youtube.com/channel/UCTLzD9A-M_ll2m7Wj45sHJg"
            target="_blank"
          >
            <YouTubeIcon sx={iconStyle} />
          </a>
        </Stack>
      </div>
    </>
  );
};

export default Home;
